module.exports = __webpack_public_path__ + "resources/7dc617f13844d1af3053548f92c5bbc3.png";